const f = {
  color: {
    background: "#ffffffff",
    border: "#dfe6ebff",
    text: {
      default: "#405261ff"
    },
    title: {
      text: "#314351ff",
      backgroundHover: "#f9fafaff"
    }
  }
};
export {
  f as accordion
};
